import React from 'react'
import Navbar from './Navbar'

const About = () => {
  return (
    <>
    <Navbar/>
    <div>
     About Us Page Comming Soon....
    </div>
    </>
  )
}

export default About
